// Body load opacity
// $(window).on("load",(function(){ 
// 	$("body").animate({opacity:1},700);   
// 	setTimeout(function() {                    
// 		 	 $('#shopify-section-template--20340864516384__87648e73-dc62-4f4d-a98b-f6a76037dca8 .scroll-trigger').addClass('active');			
// 	 }, 700);
// }));


$(window).on("load resize",function(){
var wheight = $(this).height();
	  var announcement = $('.announcement-bar').height();
	 $('.page404-video').css('height', wheight + announcement);
	  $('.bg_404 ').css('height', wheight - announcement);	
});

$(document).ready(function() {
			
			
	$('.footer-block--menu:last-child a').attr('target', '_blank');						   

// Nav hover blur option
$('.js-anchorLink').mouseover(function() {
	$('.js-anchorLink').not(this).addClass('blur');												    
	$(this).removeClass('blur');										   
}).mouseout(function(){
	$('.js-anchorLink').removeClass('blur');				
});

//Search open
$('.header__icon--search').click(function() {
	$('.search-modal').toggleClass('active');
	$('.section-header').toggleClass('open_search');
	$('.header-wrapper').toggleClass('open_search');
    $('#Search-In-Modal').val("").focus();	
});

// Search focus
// $('body').on('click', '.header__icon--search', function() {
//     $('.header__search #Search-In-Modal').val("").focus();	
// });
  
// Home page image with text slider
const slider =  $('.img-textslider').slick({
	dots: true,
	infinite: true,
	arrows:false,
	speed: 1000,
	autoplay: true,
	autoplaySpeed: 5000,
	adaptiveHeight: false,
	pauseOnHover:false,
	slidesToShow: 1,
	slidesToScroll: 1 
}); 

$('.img-textslider .slick-track').each(function() {
  if ($(this).children('.slick-slide').length === 1) { } else {
    slider.on('wheel', (function(e) {
      e.preventDefault();

      if (e.originalEvent.deltaY < 0) {
        $(this).slick('slickNext');
      } else {
        $(this).slick('slickPrev');
      }
    }));
  }
})

if ($(window).width() < 767) {
// Home page product slider
$('.mo_slider-product').slick({
	dots: false,
	infinite: true,
	arrows:false,
	speed: 1000,
	autoplay: false,
	adaptiveHeight: true,
	slidesToShow: 2,
	slidesToScroll: 1,
    touchThreshold: 50
}); 
}

// login page password show hide
$('.show-icon').click(function(){
 $(this).toggleClass('active');
	 var input = $(this).prev('input');
    if (input.attr("type") === "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});


});


//cookie code
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}      
function _fnaccept() {
    setCookie('isvisited','yes',30);
    setCookie('isvisitedpopup','yes',30);
	 
	
    $(".newsletter-popup-section").fadeOut();
  
}      
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for(var i=0; i<ca.length; i++) {
   var c = ca[i];
   while (c.charAt(0)==' ') c = c.substring(1);
   if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
}
  return "";
}
 $(function(){
      var isvisited = getCookie("isvisited");
      var isvisitedpopup = getCookie("isvisitedpopup");      
      if (isvisited == null || isvisited=='')  {
        $(window).on('load', function() {
		  setTimeout(function() {              
          $(".newsletter-popup-section").fadeIn(); 
		  }, 3000);
        });
      }   
      $(".close-popup, .popup-over").click(function() {
        setCookie('isvisited','yes', 30);
		
        $(".newsletter-popup-section").fadeOut();
      });   
});
//end cookie 




// FAQ page accordion jquery
$('body').on('click', '.header_titlefull', function() {
	//$('.box-a1').find('.level-box').stop().slideUp();
	$(this).closest('.box-a1').find('.level-box').stop().slideToggle();  	
	//$('.header_titlefull').not(this).removeClass('active');
	$(this).toggleClass('active');  
});




// Cart page total price change
$('body').on('click', '#main-cart-items .quantity__button', function() {
	setTimeout(function() {   
	var tptice = $('#totals__total-value').html();  	 
    $('.to_price').html(tptice);  
	  }, 1500);
});

// Mobile menu open
$('body').on('click', '.header__icon span i', function() {
    $('#menu-drawer').addClass('active');
	 $('body').addClass('hide-scroll');
	 setTimeout(function() {  
	$('.header__icon--menu').addClass('active');
	}, 200);
});

// Mobile menu close
$('body').on('click', '.header__icon span svg', function() {
    $('#menu-drawer').removeClass('active');
	 $('body').removeClass('hide-scroll');
	 $('.header__icon--menu').removeClass('active');
});

// Footer logo blur 
$('body').on('click', '.footer-logo svg', function() {
    $('.footer-logo').addClass('active');
		setTimeout(function() {  
	 $('.footer-logo').removeClass('active');
	 }, 1000); 



});


$('body').on('click', '.header__icon--cart', function() {
    $('body').addClass('hide-scroll');
});
$('body').on('click', '.drawer__close, #CartDrawer-Overlay', function() {
    $('body').removeClass('hide-scroll');
});


   (function() { 
     var REDIRECT_PATH = '/account'; 
   
     var selector = '#create_customer, form[action$="/account"][method="post"]', 
         $form = document.querySelectorAll(selector)[0]; 
   
     if ($form) { 
       $redirect = document.createElement('input'); 
       $redirect.setAttribute('name', 'return_to'); 
       $redirect.setAttribute('type', 'hidden'); 
       $redirect.value = REDIRECT_PATH; 
       $form.appendChild($redirect);  
     } 
   })(); 




